export default {
    name: 'outputsFinalized',
    component: () => import(/* webpackChunkName: "outputs-finalized-layout" */ '@/modules/outputs/finalized/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.outputs.finalized.index',
            component: () => import(/* webpackChunkName: "outputs-finalized-index" */ '@/modules/outputs/finalized/views/Index'),
        },
        {
            path: ':id/view',
            name: 'dashboard.outputs.finalized.view',
            component: () => import(/* webpackChunkName: "outputs-finalized-view" */ '@/modules/outputs/finalized/views/Print'),
        },
    ]
}